import { render, staticRenderFns } from "./OperationAllocations.vue?vue&type=template&id=7239f81e&scoped=true&"
import script from "./OperationAllocations.vue?vue&type=script&lang=js&"
export * from "./OperationAllocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7239f81e",
  null
  
)

export default component.exports